import React from 'react'
import {resolveProps} from '../../../utils'
import {clearProps} from '../../../utils'

import { BreadcrumbProps } from './types'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    {
      title: 'mobile'
    }
  ],
  modifiers: ['inverse'],
  states: []
}

const renderPages = (dataBreadcrumb) =>
  dataBreadcrumb?.map((item, index) => (
    <li key={index} className="mdn-Breadcrumb-list-item">
      <a
        className="mdn-Breadcrumb-link"
        role="link"
        aria-current="location"
        target={item.target}
        href={item.url}
        {...item.props}
      >
        {item.page}
      </a>
      <span className="mdn-Breadcrumb-icon mdn-Icon-direita mdn-Icon--md"></span>
    </li>
  ))

export default function Breadcrumb(props: BreadcrumbProps) {
  const { dataBreadcrumb, data, inverse, mobile, ...rest } = props
  const _props = clearProps(props)
  return (
    <nav
      {...rest}
      aria-label="breadcrumbs"
      className={resolveProps(_props, config, 'Breadcrumb')}
    >
      {mobile ? (
        <a className="mdn-Breadcrumb-link" {...rest}>
          <i
            className="mdn-Breadcrumb-icon mdn-Icon-esquerda mdn-Icon--md"
            aria-hidden="true"
          ></i>
          Voltar
        </a>
      ) : (
        <ol className="mdn-Breadcrumb-list">
          {renderPages(data || dataBreadcrumb)}
        </ol>
      )}
    </nav>
  )
}
